<template>
	<div class='result-table-4'>
		<table class='table-common'>
			<thead>
				<tr>
					<th rowspan='2'>Ярус</th>
					<th colspan='2'>Состав (фактический)</th>
					<th rowspan='2'>Причины повреждения</th>
					<th rowspan='2'>Подлежит рубке, %</th>
					<th rowspan='2'>Запас, кбм</th>
					<th colspan='2'>Назначенное мероприятие</th>
					<th rowspan='2'>Остаточная полнота</th>
					<th rowspan='2'>
						<a href='#'  v-tooltip.bottom='"открыть cсылку на НПА"' @click.prevent='toggleOP'>Доля неликвида и дров от запаса погибших деревьев, %</a>
					</th>
				</tr>
				<tr>
					<th>Доля породы</th>
					<th>Порода</th>
					<th>Вид</th>
					<th>Площадь, га</th>
				</tr>
			</thead>
			<tbody>
				<template v-if='dataIsLoading'>
					<div class='table-common__loading-container'>
						<div>
							<p-spinner class='table-common__loading-spinner'/>
						</div>
						<div class='table-common__loading-text'>Загрузка данных...</div>
					</div>
				</template>

				<template v-if='dataIsLoading && !tableData.length'>
					<tr>
						<td colspan='20' class='table-common__loading-empty-row'></td>
					</tr>
				</template>

				<template v-else>
					<tr v-for='(row, row_i) in tableData' :class='{ "total-row": (row_i === tableData.length - 1) }'>
						<td
							v-if='isLayer(row)'
							:rowspan='speciesLayerCount(row)'
							:colspan='(row_i === tableData.length - 1) ? 3 : 0'
						>
							{{ (row_i === tableData.length - 1) ? 'Итого' : row.layer == 11 ? 'единичные деревья': row.layer  }}
						</td>
						<td v-if='row_i !== tableData.length - 1'>{{ row.coeff }}</td>
						<td v-if='row_i !== tableData.length - 1'>{{ row.species }}</td>
						<td v-if='row_i === 0' :rowspan='tableData.length'>{{ row.reasons }}</td>
						<td>{{ row.felling }}</td>
						<td v-if='isLayer(row)' :rowspan='speciesLayerCount(row)'>{{ row.stock }}</td>
						<td v-if='row_i === 0' :rowspan='tableData.length'>{{ row.mzl }}</td>
						<td v-if='row_i === 0' :rowspan='tableData.length'>{{ row.s_action }}</td>
						<td v-if='row_i === 0' :rowspan='tableData.length'>{{ row.final_density }}</td>
						<td v-if='row_i === 0' :rowspan='tableData.length'>{{ row.illiquid_pct }}</td>
					</tr>
				</template>
			</tbody>
		</table>

		<p-overlay-panel ref="op">
			<div class='p-text-bold p-mb-2'>{{ NPA_REF_TITLE }}</div>
			<div>{{ NPA_REF_TEXT }}</div>
		</p-overlay-panel>
	</div>
</template>

<script>
	const GET_TABLE_DATA = process.env.VUE_APP_ROOT_API + 'get_site_data/result_tables/table3.php';

	const NPA_REF_TITLE = `П. 57 Правил осуществления мероприятий по предупреждению распространения вредных организмов, утвержденных Приказом Минприроды России от 09.11.2020 № 912.`;
	const NPA_REF_TEXT = `Уборка неликвидной древесины проводится в местах образования ветровала, бурелома, снеголома, верховых пожаров и других повреждений при наличии неликвидной и дровяной древесины более 90% от общего запаса погибших и поврежденных деревьев, а также в случаях, когда заготовка древесины погибших или поврежденных насаждений запрещена.
В первую очередь уборка неликвидной древесины производится в лесах, выполняющих функции защиты природных и иных объектов, а также в ценных лесах. На землях другого целевого назначения и иных категорий защитных лесов уборка неликвидной древесины производится в случае, если создается угроза пожарной опасности в лесах и возникновения очагов вредных организмов.`;

	export default {
		name: 'ResultTable4',
		data: () => ({
			tableData: [],
			dataIsLoading: false,

			NPA_REF_TITLE,
			NPA_REF_TEXT
		}),
		computed: {
			lpo() {
				return this.$store.state.selectedLpo.lpo;
			},

			layerList() {
				const result = [];
				for (let row of this.tableData) {
					if (!result.find(item => item.layer === row.layer)) {
						result.push(row);
					}
				}
				return result;
			}
		},

		methods: {
			toggleOP(event) {
				this.$refs.op.toggle(event);
			},

			isLayer(item) {
				return this.layerList.includes(item);
			},
			speciesLayerCount(item) {
				return this.tableData.filter(row => row.layer === item.layer).length;
			},

			getTableData() {
				this.dataIsLoading = true;

				const form = new FormData();
				form.append('lpo_id', this.lpo.lpo_id);

				fetch(GET_TABLE_DATA, {
					credentials: 'include',
					method: 'post',
					body: form
				})
				.then(res => res.json())
				.then(res => {
					this.tableData = res;
				})
				.catch(err => { throw err; })
				.finally(() => { this.dataIsLoading = false; });


			}
		},
		created() {
			this.getTableData();
		}
	};
</script>

<style lang='scss' scoped src='@/style/tables.scss'></style>

<style scoped>
	.total-row {
		font-weight: bold;
	}
</style>